import { IChannel } from 'shared/types/channel'
import { ChannelMap } from '.'

export const MAX_DEPTH = 3

export const getChannelDepth = (channel: IChannel, channels: ChannelMap) => {
    let parent = channels[channel.parent]
    let depth = 0
    // don't count the root channel in the depth
    while (parent && parent?.id !== 0) {
        parent = channels[parent.parent]
        depth++
    }
    return depth
}
